// extracted by mini-css-extract-plugin
module.exports = {"login":"Deprecated_login__pAUw0","header":"Deprecated_header__EMVEm","body":"Deprecated_body__wZ0II","center":"Deprecated_center__1VBXl"};